import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	productsRangeDetails: [],
};

const productsRangeSettingsSlice = createSlice({
	name: 'productsRange',
	initialState: initialState,
	reducers: {
		setProductsRange: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setProductsRange, reset } = productsRangeSettingsSlice.actions;

export default productsRangeSettingsSlice.reducer;